import { forwardRef } from "react";
import { DemographicsForm, type ProfileEditActions, type DemographicsFormHandle } from "@/components/demographics/DemographicsForm";
import type { ProfileInfoMode } from "@/hooks/useDemographicsForm";

export type { ProfileInfoMode };

export interface ProfileInfoProps {
  /** "profile" = Update button only (Profile page). "wizard" = Back + Continue (complaint flow). */
  mode?: ProfileInfoMode;
  /** Called when Back is clicked (wizard only). */
  onBack?: () => void;
  /** Called after successful update when Continue is clicked (wizard only). */
  onSaveAndContinue?: () => void;
  /** Profile mode only: called with edit actions so parent can render Edit/Update in tab bar. */
  onEditActions?: (actions: ProfileEditActions) => void;
}

export const ProfileInfo = forwardRef<DemographicsFormHandle, ProfileInfoProps>(function ProfileInfo(
  { mode = "profile", onBack, onSaveAndContinue, onEditActions },
  ref
) {
  return (
    <DemographicsForm
      ref={ref}
      mode={mode}
      onBack={onBack}
      onSaveAndContinue={onSaveAndContinue}
      onEditActions={onEditActions}
    />
  );
});
